export default "__VITE_ASSET__yoA3w3zT__"